import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import configureHoneybadger from "^/config/configureHoneybadger";
import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";
import PageWrapper from "^/Components/PageWrapper";
import { AuthenticationProvider } from "^/Components/Authentication/AuthenticationProvider";
import { Tracking } from "./Components/Tracking";
import ErrorBoundary from "./Components/ErrorBoundary";
import { CookieConsentProvider } from "./Components/CookieConsentContext";

export const helmetContext = {};

export const honeybadger = Honeybadger.configure(configureHoneybadger());

const ScrollToTopOnBack = () => {
  // scroll to top of page if navigating with browser buttons
  useEffect(() => {
    const onPopState = () => {
      const { hash } = window.location;

      // slight delay to allow content to render, brwoser may jump to previous scroll position otherwise
      setTimeout(() => {
        if (!hash) {
          // no anchor scroll to top
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        } else {
          // with anchor scroll to anchor
          const targetId = hash.substring(1); // remove '#'
          const targetEl = document.getElementById(targetId);
          if (targetEl) {
            targetEl.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }, 80);
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return null;
};

export function App({ appWrapperRef }) {
  return (
    <>
      <ScrollToTopOnBack />
      <HelmetProvider context={helmetContext}>
        <HoneybadgerErrorBoundary
          honeybadger={honeybadger}
          ErrorComponent={ErrorBoundary}
        >
          <CookieConsentProvider>
            <AuthenticationProvider>
              <div ref={appWrapperRef}>
                <PageWrapper />
              </div>
            </AuthenticationProvider>
            <Tracking />
          </CookieConsentProvider>
        </HoneybadgerErrorBoundary>
      </HelmetProvider>
    </>
  );
}
